export const AUTH_CLEAR = 'AUTH_CLEAR';
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const LOADER_START = 'LOADER_START';
export const LOADER_STOP = 'LOADER_STOP';

export const FORGOT_PASSWORD_START = 'FORGOT_PASSWORD_START';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';
export const FORGOT_PASSWORD_RESET = 'FORGOT_PASSWORD_RESET';
export const FORGOT_PASSWORD_HASH_SUCCESS = 'FORGOT_PASSWORD_HASH_SUCCESS';

export const MANAGEMENT_COMPANIES_START = 'MANAGEMENT_COMPANIES_START';
export const MANAGEMENT_COMPANIES_SUCCESS = 'MANAGEMENT_COMPANIES_SUCCESS';
export const MANAGEMENT_COMPANIES_FAIL = 'MANAGEMENT_COMPANIES_FAIL';

export const ESCROW_COMPANIES_START = 'ESCROW_COMPANIES_START';
export const ESCROW_COMPANIES_SUCCESS = 'ESCROW_COMPANIES_SUCCESS';
export const ESCROW_COMPANIES_FAIL = 'ESCROW_COMPANIES_FAIL';

export const DEVELOPERS_START = 'DEVELOPERS_START';
export const DEVELOPERS_SUCCESS = 'DEVELOPERS_SUCCESS';
export const DEVELOPERS_FAIL = 'DEVELOPERS_FAIL';

export const LENDERS_START = 'LENDERS_START';
export const LENDERS_SUCCESS = 'LENDERS_SUCCESS';
export const LENDERS_FAIL = 'LENDERS_FAIL';

export const POLICY_CARRIERS_START = 'POLICY_CARRIERS_START';
export const POLICY_CARRIERS_SUCCESS = 'POLICY_CARRIERS_SUCCESS';
export const POLICY_CARRIERS_FAIL = 'POLICY_CARRIERS_FAIL';

export const ASSOCIATIONS_START = 'ASSOCIATIONS_START';
export const ASSOCIATIONS_SUCCESS = 'ASSOCIATIONS_SUCCESS';
export const ASSOCIATIONS_FAIL = 'ASSOCIATIONS_FAIL';
